import React, { useState } from 'react';
import Container from '@mui/material/Container';
import Grid from '@mui/material/Grid';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputAdornment from '@mui/material/InputAdornment';
import Divider from '@mui/material/Divider';
import EqualizerIcon from '@mui/icons-material/InsertChartOutlined';
import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';

import { AutoSaveProvider, useAutoSaveState, SaveButton, NameField } from '../lib/useAutoSaveState'
import estimateVelocity from '../lib/estimateVelocity'
import toFixed from '../lib/toFixed'

function VelocityEstimation() {
  const [ knownWeight, setKnownWeight ] = useAutoSaveState('knownWeight', '')
  const [ knownVelocity, setKnownVelocity ] = useAutoSaveState('knownVelocity', '')
  const [ weight, setWeight ] = useAutoSaveState('weight', '')
  const [ preview, setPreview ] = useAutoSaveState('preview', null)
  const [ estimate, setEstimate ] = useState('')
  const [ useEfficiency, setUseEfficiency ] = useAutoSaveState('useEfficiency', true)

  const calculate = () => {
    const velocity = estimateVelocity(
      parseFloat(weight),
      parseFloat(knownWeight),
      parseFloat(knownVelocity),
      useEfficiency
    )
    setEstimate(velocity)
    setPreview(`Velocity Estimate: ${toFixed(velocity, 1)} fps`)
    window.gtag('event', 'calculate-velocity-estimate')
  }

  return (
    <Container maxWidth="lg" sx={{ mt: 4, mb: 4 }}>
      <Grid container spacing={3} justifyContent="center" >
        <Grid container justifyContent="center" xs={12} style={{ position: 'relative' }}>
          <Typography variant="h2" component="h1" gutterBottom>
            Velocity Estimation
          </Typography>
          <SaveButton />
        </Grid>
        <NameField />
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <TextField fullWidth label="Known Bullet Weight" autoFocus value={knownWeight} onChange={e => setKnownWeight(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">grains</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Known Bullet Velocity" value={knownVelocity} onChange={e => setKnownVelocity(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">fps</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <TextField fullWidth label="Unknown Bullet Weight" value={weight} onChange={e => setWeight(e.target.value)} InputProps={{ endAdornment: <InputAdornment position="end">grains</InputAdornment> }} />
              </Grid>
              <Grid item xs={12}>
                <FormControlLabel
                  control={<Checkbox checked={useEfficiency} onChange={e => setUseEfficiency(e.target.checked)} />}
                  label="Adjust for Efficiency"
                />
              </Grid>
            </Grid>
          </Paper>
        </Grid>
        <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Button variant="contained" onClick={calculate}>Calculate</Button>
            </Grid>
          </Paper>
        </Grid>
        {estimate && <Grid item xs={8}>
          <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}>
            <Grid container xs={12} justifyContent="center">
              <Typography variant="h5" gutterBottom>
                <EqualizerIcon /> Results
              </Typography>
            </Grid>
            <Divider style={{ marginBottom: '20px', marginTop: '20px' }} />
            <Box display="flex" justifyContent="space-around" mb={2}>
              <Typography variant="h4"><b>Velocity Estimate:</b> {toFixed(estimate, 1)} fps</Typography>
            </Box>
          </Paper>
        </Grid>}
      </Grid>
    </Container>
  );
}

export default function WrappedVelocityEstimation() {
  return (
    <AutoSaveProvider>
      <VelocityEstimation />
    </AutoSaveProvider>
  )
}
